import classNames from 'classnames/bind';
import { optionalProp } from '../../../core';
import type { PaginationProps } from '../../types/propType';
import { AdminPaginationStyle, TableRowType } from '../../Table';
import MLP1Pagination from '../MLP1/MLP1Pagination';
import { usePaginationPosition } from '../../../hooks';
import RowsPerPageSelector from '../RowsPerPageSelector/RowsPerPageSelector';
import styles from './RowPerPageAndNextPage.module.scss';

const cx = classNames.bind(styles);
const RowPerPageAndNextPage = ({
  totalRecords,
  currentPage = 0,
  rowsPerPage = 5,
  updatePaginationData,
  startRecordIndex = () => 1,
  endRecordIndex,
  pageSizeData,
  scrollToTopRefId,
  adminPaginationStyle,
  enableStickyPagination,
  ...rest
}: PaginationProps) => {
  usePaginationPosition(enableStickyPagination, currentPage, totalRecords, scrollToTopRefId, rowsPerPage);

  const CPaginationContainerClassname = cx('pagination-container', {
    'row-per-next-page-pagination': adminPaginationStyle === AdminPaginationStyle.WITH_ROW_PER_NEXT_PAGE,
    'sticky-pagination': enableStickyPagination,
  });

  return (
    <div id={'pagination-container'} className={CPaginationContainerClassname}>
      {pageSizeData && (
        <RowsPerPageSelector
          rowsPerPage={rowsPerPage}
          pageSizeData={pageSizeData}
          currentPage={currentPage}
          totalRecords={totalRecords}
          startRecordIndex={startRecordIndex}
          {...optionalProp('endRecordIndex', endRecordIndex)}
          {...optionalProp('updatePaginationData', updatePaginationData)}
          {...optionalProp('scrollToTopRefId', scrollToTopRefId)}
        />
      )}
      <MLP1Pagination
        updatePaginationData={updatePaginationData}
        totalRecords={totalRecords}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        hasNextPage
        {...rest}
        paginationType={TableRowType.COMPACT}
        {...optionalProp('scrollToTopRefId', scrollToTopRefId)}
        {...optionalProp('enableStickyPagination', enableStickyPagination)}
      />
    </div>
  );
};

export default RowPerPageAndNextPage;
